import { Icon } from '@synergy/icons';
import { Button, Flex } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useGlobalFilterContext } from "../../../contexts/GlobalFilterProvider";
import Theme from "../../../styles/Theme/Theme";
import { SelectAtomic } from "../../Global/Atomics/SelectAtomic";
import Spinner from "../../Global/Atomics/Spinner";
import { Text } from "../../Global/Atomics/Text";

const FiltersWrapper = styled.div.attrs({
    className: 'with-bg-color',
})`
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: ${Theme.color['neutral-2']};
    padding: ${Theme.spacing['s07']} ${Theme.spacing['s05']};
    width: auto;
    height: -webkit-fill-available; /* Doesnt work in all browsers */
    height: 100%; /* works in firefox and others browseres */

    &.is-open {
        width: 234px;
    }

    .filters-header{
        display: flex;
        margin-bottom: ${Theme.spacing['s07']};

        .filters-title{
            display: flex;
            align-items: center;
        }
        .filters-button{
            cursor: pointer;
        }
    };

    .filter-content{
        overflow-y: auto;
        height: 100%;

        &::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: ${Theme.color['coolgray-2']};
            border-radius: 10px;
        }
        
        .filter-content-item{
            margin-bottom: ${Theme.spacing['s07']};

            .antdSelect{
                width: 100%;

                .ant-select-arrow{
                    color: ${Theme.color['blue-4']};
                    font-size: unset;
                }

                .ant-select-selector{
                    min-height: 48px;
                    border: none;

                    .ant-select-selection-placeholder{//if mode is none need this property to center
                        align-self: center;
                    }

                    .ant-select-selection-item{//if mode is none need this property to center
                        align-self: center;
                    }
                }
            }

            .ant-picker{
                width: 100%;
                height: 48px;
                border: none;

                .ant-picker-suffix{
                    color: ${Theme.color['blue-4']};
                }
            }
        }

        .submit-content{
            display: flex;
            flex-direction: column;
            padding: 8px 0px 0px 0px;//Top padding 32px - s07 = 8px;
            
            .buttonFilter{
                border-radius: 20px;
                cursor: pointer;
                font-size: ${Theme.typography.fontSize['text_sm_desktop']};
            }
            
            .saveFilter{
                background-color: transparent;
                height: 40px;
                border-color: ${Theme.color['coolgray-2']};
                border-style: solid;
                margin-bottom: ${Theme.spacing['s05']};

                &:hover{
                    border-color: ${Theme.color['black-1']};
                    /* background-color: ${Theme.color['coolgray-4']}; */
                }

                &:focus{
                    color: ${Theme.color['black-1']};
                    background-color: ${Theme.color['white']};
                    border-color: ${Theme.color['blue-2']};
                }

                &:disabled{
                    color: ${Theme.color['black-1']};
                    background-color: #F8F8F8;
                    cursor: not-allowed;
                    border-color: ${Theme.color['coolgray-2']};
                }
            }

            .whiteButton{
                &:disabled{
                    color: ${Theme.color['coolgray-11']};
                    background-color: ${Theme.color['coolgray-2']};
                    cursor: not-allowed;
                }
            }
        }
    }
`;

export const Filters = () => {
    const { mapViewType } = useGlobalFilterContext();
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const { dropdownEntity, entity, dropdownSubEntity, subEntity, setSubEntity } = useGlobalFilterContext();

    const [copyEntityValue, setCopyEntityValue] = useState(null);
    const [copySubEntityDropdown, setCopySubEntityDropdown] = useState(null);
    const [copySubEntityValue, setCopySubEntityValue] = useState(null);

    const onApplyFilters = () => {
        setSubEntity(copySubEntityValue);
    };

    useEffect(() => {
        if (entity) {
            setCopyEntityValue(entity);
        }
        if (subEntity) {
            setCopySubEntityValue(subEntity);
        }
        if (dropdownSubEntity) {
            setCopySubEntityDropdown(dropdownSubEntity);
        }
    }, [entity, subEntity, dropdownSubEntity]);

    const changeCopySubEntityDropdown = (cev) => {
        if (cev?.value) {
            const cities = dataRegions?.find((x) => {
                const name = x.name.split(".");
                if (name[0] === cev.value) {
                    return x;
                }
            })?.cities;

            setCopyEntityValue(cev);
            if (cities) {
                const dropdownSubEntityObject = selectSerialize(cities);
                setCopySubEntityDropdown(dropdownSubEntityObject);
                setCopySubEntityValue(dropdownSubEntityObject[0]);
            } else {
                setCopySubEntityDropdown(null);
                setCopySubEntityValue(null);
            }
        }
    }

    useEffect(() => {
        if (mapViewType !== 'map') {
            setIsOpen(false);
        }
    }, [mapViewType]);

    return (
        <FiltersWrapper className={isOpen ? " is-open" : null}>
            <div className="filters-header">
                <Button
                    className="filters-button"
                    onClick={() => { setIsOpen(!isOpen) }}
                    type="text"
                    icon={
                        <Icon iconsize={'sm'} icon={isOpen === true ? 'Collapse' : 'CollapseOpen'} color={'blue-4'} />
                    }
                    disabled={mapViewType !== 'map'}
                />
                {isOpen ?
                    <Text textcolor='coolgray-12' marginleft='s03' textsize='text_sm' textweight='regular' $alignItems='center'>{t('filters')}</Text> : null
                }
            </div>
            {isOpen ?
                <div className="filter-content">
                    <div className="filter-content-item">
                        {dropdownEntity ?
                            <SelectAtomic optionsData={dropdownEntity} handleOptionsChange={(value, record) => { changeCopySubEntityDropdown(record) }} defaultValue={copyEntityValue?.value} fullWidth={true} />
                            : <Flex justify="center"><Spinner stroke="green" size='25px' /></Flex>
                        }
                    </div>

                    {dropdownSubEntity ?
                        <div className="filter-content-item">
                            {dropdownEntity ?
                                <SelectAtomic optionsData={copySubEntityDropdown} handleOptionsChange={(value, record) => { setCopySubEntityValue(record) }} defaultValue={copySubEntityValue?.value} fullWidth={true} />
                                : <Flex justify="center"><Spinner stroke="green" size='25px' /></Flex>
                            }
                        </div>
                        : null}

                    <Flex gap='middle' vertical="true">
                        <Button shape="round" className="ant-btn-blue -small" onClick={() => onApplyFilters()}>{t('apply')}</Button>
                    </Flex>
                </div>
                : null
            }
        </FiltersWrapper >
    )
};

const selectSerialize = (array) => {
    return array?.sort((a, b) => b.buIndex - a.buIndex)?.map((x) => {
        const name = x.name.split(".");
        return {
            value: name[0],
            label: name[0],
            id: x.id,
            tenant: x.tenant,
            cities: x.cities,
            latitude: x.latitude,
            longitude: x.longitude,
            zoom: x.zoom,
        };
    });
};